import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'

import TagCloudItem from './TagCloudItem'

import './TagCloudItemGroup.scss'

const TagCloudItemGroup = props => {
  const [activeTab, setActiveTab] = useState(props.lastFaqCategoryId)
  const isMountedRef = useRef(true)

  useEffect(() => {
    isMountedRef.current = true
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    if (isMountedRef.current) {
      setActiveTab(props.lastFaqCategoryId)
    }
  }, [props.lastFaqCategoryId])

  const history = useHistory()
  const setRoute = faq => {
    const {
      faqId,
      category: { description },
    } = faq
    const path = `faq/${description}/${faqId}`
    history.push(path)
    props.handleFaqLog(faqId)
  }

  if (!props.showResults) {
    return null
  }

  return (
    <TagCloudItem
      faqs={props.faqs}
      handleOnClick={faq => setRoute(faq)}
      activeTab={activeTab}
      setActiveTab
    />
  )
}

export default TagCloudItemGroup
